export default "__VITE_ASSET__1rl9nInR__"